/*ěščřžýáíéúů*/

document.addEventListener("DOMContentLoaded", function () {
    // Scroll progress bar - only when navbar is sticky
    function initScrollProgressBar() {
        const progressBar = document.querySelector(".progress-bar");
        const submenu = document.querySelector(".submenu-function");
        if (!progressBar || !submenu) return;

        function updateProgressBar() {
            // Only update if navbar is sticky
            if (submenu.classList.contains("sticky")) {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
                const scrollPercent = (scrollTop / docHeight) * 100;

                progressBar.style.width = scrollPercent + "%";
            }
        }

        window.addEventListener("scroll", updateProgressBar);
        updateProgressBar();
    }

    initScrollProgressBar();

    // Sticky submenu funkcionalita
    function initStickySubmenu() {
        const header = document.querySelector("header, .site-header");
        const submenu = document.querySelector(".submenu-function");
        const adminBar = document.querySelector("#wpadminbar");

        if (!header || !submenu) return;

        let headerHeight = header.offsetHeight;
        let adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
        let submenuHeight = submenu.offsetHeight;
        let submenuOffset = submenu.getBoundingClientRect().top + window.pageYOffset;
        let isSticky = false;
        let stickyPlaceholder = null;
        let hideTimeout = null;

        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const triggerPoint = submenuOffset - headerHeight - adminBarHeight;

            if (scrollTop >= triggerPoint) {
                if (!isSticky) {
                    // Vytvoř placeholder pro zachování layoutu
                    stickyPlaceholder = document.createElement("div");
                    stickyPlaceholder.style.height = submenuHeight + "px";
                    stickyPlaceholder.className = "submenu-sticky-placeholder";
                    submenu.parentNode.insertBefore(stickyPlaceholder, submenu);

                    // Aktivuj sticky submenu
                    submenu.classList.add("sticky");
                    submenu.style.top = adminBarHeight + "px";

                    // Zajisti že je submenu viditelné na začátku - s vyšší prioritou
                    gsap.set(submenu, { y: 0, zIndex: 20 });

                    // Animace schování hlavičky
                    header.style.transform = `translateY(-100%)`;
                    header.style.transition = "transform 0.3s ease";

                    isSticky = true;
                }

                // Submenu zůstává vždy viditelné když je sticky
                clearTimeout(hideTimeout);
            } else {
                if (isSticky) {
                    // Deaktivuj sticky submenu
                    submenu.classList.remove("sticky");
                    submenu.style.top = "";
                    gsap.set(submenu, { y: 0 }); // Reset GSAP transform

                    // Zobraz hlavičku
                    header.style.transform = "translateY(0)";

                    // Odstraň placeholder
                    if (stickyPlaceholder) {
                        stickyPlaceholder.remove();
                        stickyPlaceholder = null;
                    }

                    clearTimeout(hideTimeout);
                    isSticky = false;
                }
            }
        }

        // Submenu zůstává vždy viditelné - odstraněny hover efekty

        // Throttle scroll event pro performance
        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(handleScroll);
                ticking = true;
            }
        }

        window.addEventListener("scroll", () => {
            requestTick();
            ticking = false;
        });

        // Recalculate na resize
        window.addEventListener("resize", () => {
            headerHeight = header.offsetHeight;
            adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
            submenuHeight = submenu.offsetHeight;
            submenuOffset = submenu.getBoundingClientRect().top + window.pageYOffset;

            // Pokud je sticky, aktualizuj top pozici
            if (isSticky) {
                submenu.style.top = adminBarHeight + "px";
            }
        });
    }

    // Inicializuj sticky submenu
    initStickySubmenu();

    // FAQs akordeon funkcionalita
    function initFAQs() {
        const faqItems = document.querySelectorAll(".faqs .items__item");

        faqItems.forEach((item) => {
            const header = item.querySelector(".faq-header");
            const description = item.querySelector(".faq-description");
            const icon = item.querySelector("svg");

            if (header && description) {
                // Skryj description na začátku
                description.style.display = "none";

                // Přidej click event
                header.addEventListener("click", function () {
                    const isOpen = description.style.display !== "none";

                    // Zavři všechny ostatní FAQs
                    faqItems.forEach((otherItem) => {
                        const otherDescription = otherItem.querySelector(".faq-description");
                        const otherIcon = otherItem.querySelector("svg");

                        if (otherItem !== item && otherDescription) {
                            $(otherDescription).slideUp(300);
                            if (otherIcon) {
                                otherIcon.style.transform = "rotate(0deg)";
                            }
                        }
                    });

                    // Toggle aktuální FAQ
                    if (isOpen) {
                        $(description).slideUp(300);
                        if (icon) {
                            icon.style.transform = "rotate(0deg)";
                        }
                    } else {
                        $(description).slideDown(300);
                        if (icon) {
                            icon.style.transform = "rotate(180deg)";
                        }
                    }
                });

                // Nastav cursor pointer pro header
                header.style.cursor = "pointer";

                // Přidej transition pro ikonu
                if (icon) {
                    icon.style.transition = "transform 0.3s ease";
                }
            }
        });
    }

    // Inicializuj FAQs
    if (document.querySelector(".faqs")) {
        initFAQs();
    }
});
